import { drilldownData, ModuleFields } from "@utils/drilldownData";

export const fields: any = {
  notificationType: drilldownData["notificationType"].map(
    ({
      fieldName,
      placeholder,
      name,
      formType,
      validation,
      className,
      loadOptions,
      options,
      usedFileType,
      note,
    }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      loadOptions,
      options,
      usedFileType,
      note,
    })
  ),
  repeatType: drilldownData["repeatType"].map(
    ({
      fieldName,
      placeholder,
      name,
      formType,
      validation,
      className,
      loadOptions,
      options,
      usedFileType,
      note,
    }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      loadOptions,
      options,
      usedFileType,
      note,
    })
  ),
  promotion: drilldownData["promotion"].map(
    ({
      fieldName,
      placeholder,
      name,
      formType,
      validation,
      className,
      loadOptions,
      options,
      usedFileType,
      note,
    }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      loadOptions,
      options,
      usedFileType,
      note,
    })
  ),
  geoLocationPromotions: drilldownData["geoLocationPromotions"].map(
    ({
      fieldName,
      placeholder,
      name,
      formType,
      validation,
      className,
      loadOptions,
      options,
      usedFileType,
      note,
    }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      loadOptions,
      options,
      usedFileType,
      note,
    })
  ),
  geoLocationPromotionLevels: drilldownData["geoLocationPromotionLevels"].map(
    ({
      fieldName,
      placeholder,
      name,
      formType,
      validation,
      className,
      loadOptions,
      options,
      usedFileType,
      note,
    }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      loadOptions,
      options,
      usedFileType,
      note,
    })
  ),
  geoLocationOffer: drilldownData["geoLocationOffer"].map(
    ({
      fieldName,
      placeholder,
      name,
      formType,
      validation,
      className,
      loadOptions,
      options,
      usedFileType,
      note,
    }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      loadOptions,
      options,
      usedFileType,
      note,
    })
  ),
};
